import { FormProperty } from '../enums';

const FormProps = {
  props: {
    [FormProperty.IsLoading]: {
      type: Boolean,
      default: false,
    },
    [FormProperty.LoadOptionsHandler]: {
      type: Function,
      default: () => ([]),
    },
  },
};

export default FormProps;
